import React from "react";

const experiences = [
  {
    title: "Founder",
    company: "Magnet Labs OÜ",
    date: "Jan 2026 – Present",
    summary:
      "Founded Magnet Labs, building AI infrastructure that cuts GPU costs by 31% while retaining 97% model quality. Selected for Anthropic Claude Startups, Neo4j Startup Program, and İTÜ Çekirdek.",
  },
  {
    title: "AI Engineer",
    company: "Dersheryerde Inc.",
    date: "Sep 2025 – Jan 2026",
    summary: "Built LLM-based tutoring agents and backend services for 1e1.ai.",
  },
  {
    title: "Software Developer Intern",
    company: "ETİ Gıda Sanayi ve Ticaret A.Ş.",
    date: "Jul 2025 – Sep 2025",
    summary: "Built internal web and mobile systems and a cybersecurity monitoring platform.",
  },
  {
    title: "Founder",
    company: "UniClubs",
    date: "May 2025 – Present",
    summary: "Built and launched UniClubs mobile app. 100+ clubs onboarded, 500+ downloads, live on iOS and Android.",
  },
  {
    title: "Software Developer",
    company: "Teknevia Inc.",
    date: "Dec 2024 – Feb 2025",
    summary: "Improved teknevia.com performance and shipped search features for Ismarlıyo.",
  },
  {
    title: "Founder",
    company: "mmpihesaplama.com",
    date: "Oct 2024 – Present",
    summary: "Built an automated MMPI scoring platform with AI interpretation, 5,000+ users.",
  },
  {
    title: "Software Developer Intern",
    company: "Usta Bilgi Sistemleri Inc.",
    date: "Jun 2023 – Jul 2023",
    summary: "Built an HR system for 200+ employees, improving database performance ~30%.",
  },
];

export default function Experience() {
  return (
    <section id="experience" className="w-full bg-[#0d0d0d] py-20">
      <div className="px-6 md:px-10">
        <h2 className="text-5xl md:text-6xl font-semibold tracking-tight text-white/90">
          Experience
        </h2>
      </div>

      <div className="mt-12 px-6 md:px-10">
        <div className="space-y-6 md:space-y-7">
          {experiences.map((exp, i) => (
            <div
              key={`${exp.company}-${exp.date}-${i}`}
              className="grid grid-cols-1 items-baseline gap-1 md:grid-cols-[180px_1fr] md:gap-8"
            >
              <div className="text-[13px] text-neutral-500">{exp.date}</div>
              <div>
                <h3 className="text-lg md:text-xl font-medium text-neutral-200">
                  {exp.title}
                  <span className="font-normal text-neutral-500"> · {exp.company}</span>
                </h3>
                <p className="mt-1 text-[15px] md:text-[16px] leading-relaxed text-neutral-400">
                  {exp.summary}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
